import { render, staticRenderFns } from "./turnOverInfo.vue?vue&type=template&id=55bad482&scoped=true"
import script from "./turnOverInfo.vue?vue&type=script&lang=js"
export * from "./turnOverInfo.vue?vue&type=script&lang=js"
import style0 from "./turnOverInfo.vue?vue&type=style&index=0&id=55bad482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bad482",
  null
  
)

export default component.exports